// # Payment Processing Component
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../../../../auth/state';
import SharedHeader from '../../../../../components/SharedHeader';
import DashboardFooter from '../../../../../components/DashboardFooter';
import { FaMoneyCheckAlt, FaHistory, FaChartLine } from 'react-icons/fa';
import './payments.css';

const PaymentProcessing = () => {
  const navigate = useNavigate();
  const { isAdmin } = useAuthStore();

  // # Redirect if not admin
  React.useEffect(() => {
    if (!isAdmin) {
      navigate('/dashboard');
    }
  }, [isAdmin, navigate]);

  // # Payment sections configuration
  const paymentSections = [
    {
      title: 'Register Payment',
      icon: <FaMoneyCheckAlt size={40} />,
      description: 'Record new payments and transactions',
      path: '/admin/financial/payments/register'
    },
    {
      title: 'Payment History',
      icon: <FaHistory size={40} />,
      description: 'View and manage payment records',
      path: '/admin/financial/payments/history'
    },
    {
      title: 'Payment Analytics',
      icon: <FaChartLine size={40} />,
      description: 'Analyze payment trends and statistics',
      path: '/admin/financial/payments/analytics'
    }
  ];

  return (
    <div className="fnc_pay_page">
      <SharedHeader />
      
      <main className="fnc_pay_content">
        <div className="fnc_pay_header">
          <h1>Payment Processing</h1>
          <button 
            className="fnc_pay_back-button"
            onClick={() => navigate('/admin/financial')}
          >
            Back to Financial System
          </button>
        </div>

        <div className="fnc_pay_sections-grid">
          {paymentSections.map((section, index) => (
            <div 
              key={index}
              className="fnc_pay_section-card"
              onClick={() => navigate(section.path)}
            >
              <div className="fnc_pay_card-icon">
                {section.icon}
              </div>
              <h3>{section.title}</h3>
              <p>{section.description}</p>
            </div>
          ))}
        </div>
      </main>

      <DashboardFooter />
    </div>
  );
};

export default PaymentProcessing;
